import {
  AlertColor,
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  InputAdornment,
  TextField,
  Theme,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { globalTheme } from "../../../common/theme";
import createStyles from "@mui/styles/createStyles";
import axios from "axios";
import React from "react";
import { ProductInfo, ProductListItem } from "./ProductAccessories";
import { SnackBarMessage, SnackBarMessageProps } from "../../component/SnackBarMessage";
import Title from "../../component/Title";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { GridColumns, GridToolbarContainer } from "@mui/x-data-grid";
import { CustomTablePagination } from "../../component/CustomPagination";
import { Add, ContentCopy, Edit, Search, Upload } from "@mui/icons-material";
import { renewToken } from "../../../services/AuthService";
import { useConstructor } from "../../../common/UseConstructor";
import { ProductSingle, ProductSingleHandle } from "./ProductSingle";
import { OpenMode } from "../../../common/Enums";
import { Categories, ProductRegions, SubCategories } from "../../../common/Constants";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
  })
);

export function ProductManagement() {
    const style = { ...useStyles(), ...globalTheme() };

    const tinyScreen = useMediaQuery('(max-width:1366px)');
    const smallScreen = useMediaQuery('(max-width:1920px)');
    const normalScreen = useMediaQuery('(max-width:2560px)');

    const singleModalRef = React.useRef<ProductSingleHandle>(null);

    const [open, setOpen] = React.useState(false);
    const [loading, setLoading] = React.useState<boolean>(false);

    const [gridData, setGridData] = React.useState<ProductListItem[]>([]);
    const [selectedProductId, setSelectedProductId] = React.useState<number>(0);

    //Grid columns
    const columns: GridColumns = [
      { field: 'model', headerName: '型式', flex: 3, type: 'string', editable: false },
      { field: 'nameJpn', headerName: '製品名', flex: 5, type: 'string', editable: false },
      { field: 'description', headerName: '針長', flex: 2.5, type: 'string', editable: false },
      { field: 'productCode', headerName: '商品CD', flex: 2.5, type: 'string', editable: false },
      { field: 'newCDCode', headerName: '品目CD', flex: 2.5, type: 'string', editable: false },
      { field: 'price', headerName: '標準価格', flex: 1.2, type: 'number' },
      { field: 'scaw', headerName: 'SCAW', flex: 1.2, type: 'string' },
      { field: 'category', headerName: 'Category', flex: 1.5, type: 'string', editable: false },
      { field: 'subCategory', headerName: 'Sub Category', flex: 1.5, type: 'string', editable: false },
      { field: 'remark', headerName: '备註', flex: 3, type: 'string', editable: false }
    ];

    const [searchText, setSearchText] = React.useState("");
    const [excludeNoUse, setExcludeNoUse] = React.useState<boolean>(true);

    const [searchData, setSearchData] = React.useState<any>({
      pageSize: 15,
    });

    //Dialogs and snacks
    const [snackSettings, setSnackSettings] =
      React.useState<SnackBarMessageProps>({
        open: false,
        message: "",
        subMessage: "",
        severity: undefined,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });

    function showSnackBar(message: string, subMessage: string, colour?: AlertColor) {
      setSnackSettings({
        open: true,
        message: message,
        subMessage: subMessage,
        severity: colour,
        onClose: () => setSnackSettings({ open: false, message: "", subMessage: "", severity: undefined, onClose: () => {}})
      });
    }

    function CustomToolbar() {
      const [inputText, setInputText] = React.useState(searchText);
      return (
        <GridToolbarContainer style={{ display: 'flex' }}>
          <TextField className={style.ModalContentFieldOneThirdWidth}
            style={{ minWidth: '100px', width: '100%' }}
            label="商品CD / 型式 / 製品名 / SCAW"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            onKeyDown={(e) => KeyPressed(e.key, inputText, excludeNoUse)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => {
                      setSearchText(inputText);
                      SearchProduct(inputText, excludeNoUse);
                    }}><Search />
                  </IconButton>
                </InputAdornment>
              ),
            }}   
          />
          <div style={{ width: "10px", minWidth: "10px" }}></div>
          <FormControlLabel
            control={<Checkbox checked={excludeNoUse} onChange={(e) => {
                    setExcludeNoUse(e.target.checked);
                    SearchProduct(inputText, e.target.checked);
                }}/>}
            label="Exclude No Use"
          />
          <div style={{ flexGrow: 1, minWidth: "10px" }}></div>
          <Button style={{ width: "120px", minWidth: "100px" }} 
            variant="contained" size="small" color="secondary" startIcon={<Upload />} aria-label="upload file" component="label">Upload
              <input hidden accept=".tsv" type="file" onChange={ImportProduct} />
          </Button>
          <div style={{ width: "10px", minWidth: "10px" }}></div>
          <Button style={{ width: "120px", minWidth: "100px" }}
            variant="contained" size="small" color="secondary" startIcon={<Add />} onClick={() => NewProduct()}>Add</Button>
          <div style={{ width: "10px", minWidth: "10px" }}></div>
          <Button style={{ width: "120px", minWidth: "100px" }} disabled={ selectedProductId==0 }
            variant="contained" size="small" color="secondary" startIcon={<Edit />} onClick={(e) => EditProduct(selectedProductId)}>Edit</Button>
          <div style={{ width: "10px", minWidth: "10px" }}></div>
          <Button style={{ width: "120px", minWidth: "100px" }} disabled={ selectedProductId==0 }
            variant="contained" size="small" color="secondary" startIcon={<ContentCopy />} onClick={(e) => CopyProduct()}>Copy</Button>
          <div style={{ width: "10px", minWidth: "10px" }}></div>
        </GridToolbarContainer>
      );
    }

    function KeyPressed(key: string, inputText: string, excludeNoUse: boolean) {
      if(key === 'Enter'){
        setSearchText(inputText);
        SearchProduct(inputText, excludeNoUse);
      }      
    }

    function ImportProduct(e: React.ChangeEvent<HTMLInputElement>) {
      e.preventDefault();
      const fileList = e.target.files;
  
      if (!fileList) return;
      
      if (fileList[0]) {
          const formData = new FormData();
          formData.append("file", fileList[0]);
  
          axios.put('Api/V1/Product/Upload', formData, {
              headers: {
                  'Content-Type': 'multipart/form-data'
              }
          })
              .then(function (response) {
                  if (response.data)
                    showSnackBar("Product imported successfully.", "", "success");
                  else
                    showSnackBar("Product imported failed.", response.data, "error");
              })
              .catch(function (error) {
                  showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
              });

      } 
    }

    function NewProduct() {
      let product: ProductInfo = {
        id: 0,
        productID: 0,
        unit: "",
        minOrderQty: 1,
        minQuotationPercent: 70,
        minPOPercent: 55,
        regionCode: ProductRegions[1].id,
        category: Categories[0],
        subCategory: SubCategories[4].subCategory,
        staff: "",
        staffID: 0
      }
      singleModalRef.current?.Initialise(OpenMode.NEW, product);
    }

    function EditProduct(productId: number) {
      setLoading(true);

      if (productId > 0)
      {
        const params = { productId: productId };
        axios.get<ProductInfo>('Api/V1/Product', {
          params,
          headers: {
            'Content-Encoding': 'gzip'
          }
          })
          .then((result) => {
            let product = result.data;
            product.staffID = 0;
            singleModalRef.current?.Initialise(OpenMode.EDIT, product);
            setLoading(false);
          },
            (error) => {
            setLoading(false);
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          }
          )
          .catch((error) => {
            setLoading(false);
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          });
      }
    }

    function CopyProduct() {
      setLoading(true);

      if (selectedProductId > 0)
      {
        const params = { productId: selectedProductId };
        axios.get<ProductInfo>('Api/V1/Product', {
          params,
          headers: {
            'Content-Encoding': 'gzip'
          }
          })
          .then((result) => {
            let product = result.data;
            product.staffID = 0;
            product.productCode = product.productCode + '(COPY)';
            product.model = product.model + '(COPY)';
            product.newCDCode = product.newCDCode + '(COPY)';
            singleModalRef.current?.Initialise(OpenMode.COPY, product);
            setLoading(false);
          },
            (error) => {
            setLoading(false);
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          }
          )
          .catch((error) => {
            setLoading(false);
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          });
      }
    }

    function SearchProduct(inputText: string, excludeNoUse: boolean) {
      setLoading(true);

      const params = { searchString: inputText, excludeNoUse: excludeNoUse };
      axios.get<ProductListItem[]>('Api/V1/Product/Search', {
        params,
        headers: {
          'Content-Encoding': 'gzip'
        }
      })
        .then((result) => {
          result.data.forEach(i => {
            i.id = i.productID;
            i.selected = false;
          });
          setGridData(result.data)
          setLoading(false);
        },
          (error) => {
            setGridData([]);
            setLoading(false);
            console.log(error);
            showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
          }
        )
        .catch((error) => {
          setLoading(false);
          console.log(error);
          showSnackBar(error.toString(), error?.response?.data?.errors[0], "error");
        });
    }

    useConstructor(() => Initialise())
    function Initialise() {
      setOpen(true);
      renewToken();
      
      setSelectedProductId(0);
      setSearchText("");
      setExcludeNoUse(true);
      SearchProduct("", true);
    }

    return (
        <div className={style.PageMain}>
            <Title pageTitle="Product List" />
            <div className={style.PageContent}>
              <DataGridPro
                getRowId={(row) => row.id}
                rows={gridData}
                columns={columns}
                pageSize={searchData.pageSize}
                onPageSizeChange={(pageSize) => setSearchData({ ...searchData, pageSize: pageSize })}
                pagination
                rowsPerPageOptions={[15, 30, 50, 100]}
                loading={loading}
                components={{
                  Toolbar: CustomToolbar,
                  Footer: CustomTablePagination
                }}
                componentsProps={{
                  footer: { rowsPerPageOptions: [15, 30, 50, 100] }
                }}
                rowHeight={tinyScreen ? 20 : (smallScreen ? 24 : 28)}
                onRowClick={(params) => setSelectedProductId(params.row.productID)}
                onRowDoubleClick={(params) => EditProduct(params.row.productID)}
              />
            </div>

          <SnackBarMessage {...snackSettings} />

          <ProductSingle
            ref={singleModalRef}
            onClose={(saved: boolean, product: ProductListItem) => {
              let tempGridData = [...gridData];
              let itemIndex = tempGridData.findIndex(x => x.productID === product.productID);
              if (itemIndex===-1)
              {
                product.id = product.productID;
                tempGridData.unshift(product);
              }
              else
              {
                product.id = product.productID;
                tempGridData[itemIndex] = product;
              }
              setGridData(tempGridData);
            }}
          />

        </div>
    );


  }

